/**
 * The four sign-ins, as a HINT on the form (docs/06 §"The four accounts").
 *
 * This is a four-person internal system behind a single door: everyone who will
 * ever see this screen already knows the addresses, and making them type one
 * from memory on a wall tablet with an on-screen keyboard is friction for no
 * security. Tapping a name fills the field; it never fills a password.
 *
 * The list is presentation only. The SERVER decides which accounts exist, which
 * person each acts as and who may change settings — nothing here is trusted for
 * any of that.
 */
export interface AccountHint {
  readonly email: string
  readonly label: string
  /** A short qualifier shown beside the name, where one is worth saying. */
  readonly note?: string
}

export const ACCOUNT_HINTS: readonly AccountHint[] = [
  { email: 'bayo@sotech.com', label: 'Bayo', note: 'admin' },
  { email: 'amr@sotech.com', label: 'Amr' },
  { email: 'aly@sotech.com', label: 'Aly' },
  { email: 'ipad@sotech.com', label: 'Wall tablet', note: 'this iPad' },
]
